import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'jackery-tag',
  styleUrl: 'jackery-tag.css',
  shadow: true,
})
export class JackeryTag {

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }

}
